const EventTagMapping: any = {
  CALL_STARTED: { type: 'callStatus', map: 'IN_CALL' },
  PRONOTES: { type: 'callStatus', map: 'EDITING_NOTES' },
  CALL_ENDED: { type: 'callStatus', map: 'GENERATING_NOTES' },
  CALL_ENDED_WO_NOTE: {
    type: 'callStatus',
    map: 'CALL_START_WAITING_WO_NOTES',
  },
  SUBMIT_NOTE: { type: 'callStatus', map: 'CALL_START_WAITING' },
  STATUS_AMBER: { type: 'status', map: 'AUDIO_ISSUE' },
  STATUS_OK: { type: 'status', map: 'ONLINE' },
  AGENT_ONLINE: { type: 'status', map: 'ONLINE' },
  AGENT_OFFLINE: { type: 'status', map: 'OFFLINE' },
  'PRONOTES-FAILED': { type: 'callStatus', map: 'NOTES_FAILED' },
};

export default EventTagMapping;
